import axios from 'axios';
import BaseAPI from './base/base-api';

class LicenseAgreementAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'licenseagreement';
}

export default new LicenseAgreementAPI();